"use strict";
/**
 * @author Hector J. Vasquez <ipi.vasquez@gmail.com>
 *
 * @licence
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Compares two values. This function is not recommended to use with non
 * primitive values.
 * @param a Value to compare.
 * @param b Value to compare.
 * @returns 1 if a is greater than b, 0 if a equals b, -1 otherwise.
 */
function defaultComparison(a, b) {
    if (a > b) {
        return 1;
    }
    else if (a < b) {
        return -1;
    }
    else {
        return 0;
    }
}
exports.defaultComparison = defaultComparison;



//////////////////
// WEBPACK FOOTER
// ./~/std.ts/lib/util/comparisons.js
// module id = 26
// module chunks = 0